import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CreateOrUpdateOrderCardConfiguration,
  OrderCard,
  OrderCardConfiguration,
  OrderCardPage,
  SearchParams,
} from '../../model';
import { Occ } from '../../occ/occ-models';
import { ConverterService } from '../../util/converter.service';
import { ORDER_CARDS_NORMALIZER, ORDER_CARD_CONFIGURATION_NORMALIZER, ORDER_CARD_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class OrderCardsConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  getOrderCard(userId: string, code: string): Observable<OrderCard> {
    const url = this.occEndpointsService.buildUrl('orderCard', { urlParams: { userId, code } });
    return this.httpClient.get<Occ.OrderCard>(url).pipe(this.converterService.pipeable(ORDER_CARD_NORMALIZER));
  }

  getOrderCards(userId: string, searchParams: SearchParams): Observable<OrderCardPage> {
    const url = this.occEndpointsService.buildUrl('orderCards', { urlParams: { userId }, queryParams: { ...searchParams } });
    return this.httpClient.get<Occ.OrderCardPage>(url).pipe(this.converterService.pipeable(ORDER_CARDS_NORMALIZER));
  }

  getOrderCardConfigurations(userId: string, code: string): Observable<OrderCardConfiguration[]> {
    const url = this.occEndpointsService.buildUrl('orderCardConfigurations', {
      urlParams: { userId, code },
    });
    return this.httpClient.get<Occ.OrderCardConfigurationList>(url).pipe(
      map((response) => response.configurations),
      this.converterService.pipeableMany(ORDER_CARD_CONFIGURATION_NORMALIZER)
    );
  }

  getOrderCardConfiguration(userId: string, code: string, product: string): Observable<OrderCardConfiguration> {
    const url = this.occEndpointsService.buildUrl('orderCardConfiguration', {
      urlParams: { userId, code },
      queryParams: { product },
    });
    return this.httpClient
      .get<Occ.OrderCardConfiguration>(url)
      .pipe(this.converterService.pipeable(ORDER_CARD_CONFIGURATION_NORMALIZER));
  }

  updateOrderCardConfiguration(
    userId: string,
    code: string,
    configuration: CreateOrUpdateOrderCardConfiguration
  ): Observable<OrderCardConfiguration> {
    const url = this.occEndpointsService.buildUrl('orderCardConfiguration', { urlParams: { userId, code } });
    return this.httpClient
      .put<Occ.OrderCardConfiguration>(url, configuration)
      .pipe(this.converterService.pipeable(ORDER_CARD_CONFIGURATION_NORMALIZER));
  }
}
